import React from "react";
import { BookingStatusType } from "../../../../../types/baseTypes";
import { useTranslation } from "react-i18next";

interface Props {
  status: BookingStatusType;
}
function BookingStatus({ status }: Props) {
  const { t } = useTranslation();

  function bookingStatusLabel() {
    if (status === "active") {
      return t("orders.ticket_overview.status.active");
    } else if (status === "booked") {
      return t("orders.ticket_overview.status.booked");
    } else if (status === "canceled") {
      return t("orders.ticket_overview.status.canceled");
    } else if (status === "pending") {
      return t("orders.ticket_overview.status.pending");
    } else if (status === "reserved") {
      return t("orders.ticket_overview.status.reserved");
    } else if (status === "incompleted") {
      return t("orders.ticket_overview.status.incompleted");
    } else if (status === "overtime") {
      return t("orders.ticket_overview.status.overtime");
    } else if (status === "expired") {
      return t("orders.ticket_overview.status.expired");
    } else {
      return t("orders.ticket_overview.status.finished");
    }
  }
  return (
    <div
      className={`flex min-w-[90px] px-2 font-light text-sm ${
        status === "active"
          ? "bg-appLightBlue"
          : status === "booked"
          ? "bg-lightGreen"
          : status === "pending"
          ? "bg-appLightBrown"
          : status === "canceled"
          ? "bg-lightRed"
          : status === "reserved"
          ? "bg-[#EDE9FE]"
          : status === "incompleted"
          ? "bg-[#FEF3C7]"
          : status === "overtime"
          ? "bg-[#FEF3C7]"
          : status === "expired"
          ? "bg-[#FEF3C7]"
          : "bg-lightGray"
      } items-center 
    justify-center h-6 rounded-3xl`}
    >
      <div
        className={`w-2.5 h-2.5 rounded-full ${
          status === "active"
            ? "bg-appBlue"
            : status === "booked"
            ? "bg-appGreen"
            : status === "pending"
            ? "bg-appBrown"
            : status === "canceled"
            ? "bg-appRed"
            : status === "reserved"
            ? "bg-[#7C3AED]"
            : status === "incompleted"
            ? "bg-[#D97706]"
            : status === "overtime"
            ? "bg-[#B45309]"
            : status === "expired"
            ? "bg-[#D97706]"
            : "bg-deepGray"
        } mr-2.5`}
      ></div>
      <div
        className={`font-sm -mt-[2px] ${
          status === "active"
            ? "text-appBlue"
            : status === "booked"
            ? "text-appGreen"
            : status === "pending"
            ? "text-appBrown"
            : status === "canceled"
            ? "text-appRed"
            : status === "reserved"
            ? "text-[#7C3AED]"
            : status === "incompleted"
            ? "text-[#D97706]"
            : status === "overtime"
            ? "text-[#B45309]"
            : status === "expired"
            ? "text-[#D97706]"
            : "text-deepGray"
        }`}
      >
        {bookingStatusLabel()}
      </div>
    </div>
  );
}

export default BookingStatus;
